import { home } from '@/lang/en/pages/home.ts'
import { pricing } from '@/lang/en/pages/pricing.ts'
import { avg } from '@/lang/en/pages/avg.ts'
import { agents } from '@/lang/en/pages/campaigns/agents.ts'
import { gloriafood } from '@/lang/en/pages/campaigns/gloriafood.ts'

import { manager } from '@/lang/en/pages/products/manager.ts'
import { page } from '@/lang/en/pages/products/page.ts'
import { pos } from '@/lang/en/pages/products/pos.ts'
import { posdevice } from '@/lang/en/pages/products/posdevice.ts'
import { qr } from '@/lang/en/pages/products/qr.ts'
import { webshop } from '@/lang/en/pages/products/webshop.ts'
import { kiosk } from '@/lang/en/pages/products/kiosk.ts'

import { lunchroom } from '@/lang/en/pages/cases/lunchroom.ts'
import { cafetaria } from '@/lang/en/pages/cases/cafetaria.ts'
import { grillroom } from '@/lang/en/pages/cases/grillroom.ts'
import { sushi } from '@/lang/en/pages/cases/sushi.ts'
import { italian } from '@/lang/en/pages/cases/italian.ts'

import { support } from '@/lang/en/pages/info/support.ts'
import { faq } from '@/lang/en/pages/info/faq.ts'
import { downloads } from '@/lang/en/pages/info/downloads.ts'
import { integrations } from '@/lang/en/pages/info/integrations.ts'
import { terms } from '@/lang/en/pages/info/terms.ts'
import { google } from '@/lang/en/pages/integrations/google.ts'
import { facebook } from '@/lang/en/pages/integrations/facebook.ts'
import { instagram } from '@/lang/en/pages/integrations/instagram.ts'
import { mollie } from '@/lang/en/pages/integrations/mollie.ts'
import { stripe } from '@/lang/en/pages/integrations/stripe.ts'
import { lightspeed } from '@/lang/en/pages/integrations/lightspeed.ts'
import { exactonline } from '@/lang/en/pages/integrations/exactonline.ts'
import { mpluskassa } from '@/lang/en/pages/integrations/mpluskassa.ts'
import { twilio } from '@/lang/en/pages/integrations/twilio.ts'
import { winstonpos } from '@/lang/en/pages/integrations/winstonpos.ts'
import { untill } from '@/lang/en/pages/integrations/untill.ts'
import { leat } from '@/lang/en/pages/integrations/leat.ts'
import { slack } from '@/lang/en/pages/integrations/slack.ts'
import { cashdesk } from '@/lang/en/pages/integrations/cashdesk.ts'

export const pages = {
  home,
  campaigns: {
    agents,
    gloriafood,
  },
  agents,
  avg,
  products: {
    manager,
    page,
    pos,
    posdevice,
    qr,
    webshop,
    kiosk,
  },
  pricing,
  cases: {
    lunchroom,
    cafetaria,
    grillroom,
    sushi,
    italian,
  },
  info: {
    support,
    faq,
    downloads,
    integrations,
    terms,
    integrations_detail: {
      google,
      facebook,
      instagram,
      mollie,
      stripe,
      lightspeed,
      exactonline,
      mpluskassa,
      twilio,
      winstonpos,
      untill,
      leat,
      slack,
      cashdesk,
    },
  },
}
